import React from "react";
import ReactDOM from "react-dom";
import { config as faConfig } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// FontAwesome injects its base CSS as an inline <style> without a nonce, which the CSP blocks;
// load it as a bundled stylesheet instead.
faConfig.autoAddCss = false;

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
